import React, { useState } from 'react';
import { 
  Modal, Form, Input, Switch, Upload, Button, Row, Col, notification
} from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import UserCard from './UserCard';

const EditClubModal = ({ 
  visible, 
  initialValues = {}, 
  onOk, 
  onCancel,
  isClub = false
}) => {
  const [form] = Form.useForm();
  const [previewData, setPreviewData] = useState(initialValues);
  const [imageData, setImageData] = useState("");
  const [_api,setApi] = notification.useNotification();
  const setNotification=(config)=>{
    _api.open(config);
  }
  // 初始化表单值
  React.useEffect(() => {
    if (visible) {
      var club_data = initialValues.data || {};
      console.log(initialValues)
      const defaults = {
        ...initialValues,
        url: initialValues.url || "#",
        title: club_data.title || "",
        subtitle: club_data.subtitle || "",
        powered: club_data.powered || "",
        tags: club_data.tags || ""
      };
      form.setFieldsValue(defaults);
      setPreviewData(defaults);
      // 重置图片数据状态
      setImageData("");
    }
  }, [visible, initialValues, form, isClub]);

  const handleValuesChange = (_, allValues) => {
    const newData = {
      ...previewData,
      ...allValues,
      url: allValues.url || previewData.url ||  "#",
      img: imageData ? previewData.img : allValues.img
    };
    setPreviewData(newData);
  };

  // 处理图片上传
  const handleImageChange = (file) => {
    try{
      const reader = new FileReader();
      reader.onload = (e) => {
        const dataUrl = e.target.result;
        setImageData(dataUrl);
        // 设置图片路径为上传文件的名称
        const fileName = file.name;
        form.setFieldsValue({ img: fileName });
        setPreviewData(prev => ({
          ...prev,
          img: fileName
        }));
      };
      reader.readAsDataURL(file);
    } catch(e){
      setNotification({
        "type":"error",
        message:"错误",
        description:"图片上传失败:"+e.message
      })
    }
      return false;
  };

  const handleOk = () => {
    try{
      console.log({
        ...previewData,
        img_b: imageData
      });
      // 重构数据结构以符合API要求
      onOk({
        ...previewData,
        // 使用正确的图片路径
        img: `${previewData.club}.jpg`,
        url: previewData.url || '#',
        // 保留base64图片数据用于上传
        img_b: imageData
      });
      } catch(e){
        setNotification({
          type:"error",
          message:"错误",
          description:"编辑失败:"+e.message
        });
      } finally{
        form.resetFields();
      }
  };

  return (
    <Modal
      title="编辑社团信息"
      visible={visible}
      width={800}
      onOk={handleOk}
      onCancel={onCancel}
      destroyOnClose
      footer={[
        <Button key="cancel" onClick={onCancel}>
          取消
        </Button>,
        <Button key="submit" type="primary" onClick={handleOk}>
          确定
        </Button>
      ]}
    >
      {setApi}
      <Row gutter={24}>
        <Col span={12}>
          <Form
            form={form}
            layout="vertical"
            onValuesChange={handleValuesChange}
          >

            
            <Form.Item 
              name="club" 
              label="社团ID"
              rules={[{ required: true, message: '请输入社团ID' }]}
            >
              <Input disabled={!initialValues.isadd} />
            </Form.Item>
            
            <Form.Item 
              name="name" 
              label="社团名称"
              rules={[{ required: true, message: '请输入社团名称' }]}
            >
              <Input />
            </Form.Item>

            <Form.Item 
              name="title" 
              label="社团标题"
              rules={[{ required: true, message: '请输入社团标题' }]}
            >
              <Input />
            </Form.Item>
            <Form.Item 
              name="url" 
              label="社团链接"
              rules={[{ required: true, message: '请输入社团链接' }]}
            >
              <Input />
            </Form.Item>
            <Form.Item name="subtitle" label="团队简介">
              <Input.TextArea />
            </Form.Item>
            <Form.Item name="tags" label="团队副简介(可选)">
              <Input.TextArea />
            </Form.Item>
            <Form.Item name="powered" label="页脚导航">
              <Input.TextArea />
            </Form.Item>
            
            <Form.Item name="show" label="是否展示" valuePropName="checked">
              <Switch />
            </Form.Item>
            
            <Form.Item name="img" label="社团图片">
              <Upload
                accept="image/*"
                beforeUpload={handleImageChange}
                showUploadList={false}
              >
                <Button icon={<UploadOutlined />}>
                  上传社团图片
                </Button>
              </Upload>
            </Form.Item>
          </Form>
        </Col>
        
        <Col span={12}>
          <div style={{ padding: '0 20px' }}>
            <h3>预览效果</h3>
            <UserCard 
              user={{
                ...previewData,
                tag: "社团",
                text: previewData.subtitle,
                img: imageData || previewData.img,
              }} 
            />
          </div>
        </Col>
      </Row>
    </Modal>
  );
};

export default EditClubModal;